// Título/subtítulo del topbar por ruta — ver README.md (Shell: topbar).
// Puramente presentacional: no afecta ninguna lógica de negocio ni ruta existente.
const TITLES = [
	{ match: /\/credit\/add/i, title: 'Agregar crédito', sub: 'Registrar un nuevo crédito' },
	{ match: /\/credit\//i, title: 'Detalle de crédito', sub: 'Plan de pagos e historial' },
	{ match: /\/credits/i, title: 'Créditos', sub: 'Gestión y seguimiento de créditos' },
	{ match: /\/addclient/i, title: 'Agregar cliente', sub: 'Registrar un nuevo cliente' },
	{ match: /\/client\//i, title: 'Detalle de cliente', sub: 'Ficha completa del cliente' },
	{ match: /\/clients/i, title: 'Clientes', sub: 'Cartera de clientes' },
	{ match: /\/reports|\/r-/i, title: 'Reportes', sub: 'Reportes de cartera y administración' },
	{ match: /\/(caja|gastos|contabilidad)/i, title: 'Administración', sub: 'Caja y gastos' },
	{ match: /\/(users|adduser|user\/|rols|addrol|rol\/|server)/i, title: 'Seguridad', sub: 'Usuarios, roles y servidor' },
	{
		match: /\/(sucursales|locations|department|tasa-interes|periodicidad|holidays|conceptogastos|tasa-cambio)/i,
		title: 'Configuración',
		sub: 'Parámetros del sistema'
	},
	{ match: /\/account/i, title: 'Mi cuenta', sub: 'Datos de tu perfil' }
];

export const getPageTitle = (pathname, fallbackTitle) => {
	const found = TITLES.find((t) => t.match.test(pathname));
	if (found) {
		return found;
	}
	return { title: fallbackTitle || 'Panel Principal', sub: 'Resumen general de la cartera' };
};
